import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../../util/asyncComponent';

const Routes = () =>
  <Switch>

{/* <Route path={`/`}
     component={asyncComponent(() => import('./FileUpload/FileUpload'))} exact /> */}

<Route path={`/`}
     component={asyncComponent(() => import('./Evaluation/Evaluation'))} exact />

    <Route path={`/ScrutinyLogin`}
      component={asyncComponent(() => import('./Scrutiny Login/ScrutinyLogin'))} />




      
<Route path={`/Examcodes`}
      component={asyncComponent(() => import('./ExamCodes/Examcodes'))} />
    {/* <Route path={`/UserLogin`}
      component={asyncComponent(() => import('./UserLogin/UserLogin'))} />


<Route path={`/BundleKey`}
      component={asyncComponent(() => import('./BundleKey/BundleKey'))} /> */}

<Route path={`/OmrCodes`}
      component={asyncComponent(() => import('./OmrCodes/OmrCodes'))} />

<Route path={`/MarksTable`}
      component={asyncComponent(() => import('./MarkTable/MarksTable'))} />

      
<Route path={`/ScriptsPDF`}
      component={asyncComponent(() => import('./ScriptsPDF/ScriptsPDF'))} />

      {/* //Admin */}

<Route path={`/AdminLogin`}
      component={asyncComponent(() => import('./Admin Login/AdminLogin'))} />



<Route path={`/AdminExamcodes`}
      component={asyncComponent(() => import('./AdminExamcodes/AdminExamcodes'))} />

<Route path={`/AdminMainFinal`}
      component={asyncComponent(() => import('./AdminOmrCodes/AdminMainFinal'))} />

<Route path={`/AdminMarksListTable`}
      component={asyncComponent(() => import('./AdminMarksTable/AdminMarksListTable'))} />

<Route path={`/AdminMarksListTable`}
      component={asyncComponent(() => import('./AdminScriptPDF/AdminScriptPdf.js'))} />

<Route path={`/FileUpload`}
      component={asyncComponent(() => import('./FileUpload/FileUpload'))} />


    {/* <Route path={`/saved-cards`}
      component={asyncComponent(() => import('./SavedCardsAndComparisonsPage'))} />
        <Route
      path={`/cardholder-reviews`}
      component={asyncComponent(() =>
        import('./CardholderReview/CardholderReview.js')
      )}
        />
         <Route
      path={`/saved-offers`}
      component={asyncComponent(() =>
        import('./SavedOffers')
      )}
        />
          <Route
      path={`/referral`}
      component={asyncComponent(() =>
        import('./Referrals')
      )}
        />
                <Route
          path={'/cardholder-create-review'}
          component={asyncComponent(() =>
         import('./CardholderReview/AddCardholderReview.js')
      )}
                />
                 <Route
      path={`/credit-card-discounts`}
      component={asyncComponent(() =>
        import('./CreditCardDiscounts')
      )}
                />
    <Route component={asyncComponent(() =>  import('./DashboardPage'))}/> */}

  </Switch>;


export default withRouter(Routes);

